export default __webpack_public_path__ + "static/media/sms-campaign-2.48aff3fd.png";